import React from 'react';
import { getLabel } from '../../InitData';

function RecentWinnings(props) {
    return (
        <div className="widget-ultimi bg-bianco bordo-tondo margine-giu widget-betslip">
            <div className="titolo-widget-stampa maiuscolo bg-nero bianco bordo-tondo-alto-sx bordo-tondo-alto-dx">
                <span><i className="fas fa-circle"></i> {getLabel('carrello.latest_winnings')}</span>
            </div>
            <div className="contenuto-widget-ultime-v bordato-widget">
                {props.data.map((winner, i) => {
                    return (
                        <div key={i} className="d-grid ultime-vincite">
                            <div className="info-schedina-ultime-v allinea-sx">
                                <p className="grassetto">{winner.name}</p>
                            </div>
                            <div className="info-schedina-ultime-v allinea-dx">
                                <p className="testo-piccolo">{getLabel('general.importo')} <span className="testo-evidente">{winner.betAmount}</span></p>
                            </div>
                            <div className="info-schedina-ultime-v allinea-sx">
                                <p>{winner.date}</p>
                                <p>{winner.time}</p>
                            </div>
                            <div className="info-schedina-ultime-v allinea-dx">
                                <p>{getLabel('carrello.total_winnings')}</p>
                                <p className="testo-medio grassetto">{winner.winnings}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    );
}

export default RecentWinnings;